var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef } from 'react';
import { useToast } from '@homeexchange/design';
import i18n from '../i18n';
import AutocompleteService from '../utils/AutocompleteService';
import GeoRestrictions from '../api/GeoRestrictions';
var toToastStatus = function (severity) { return (severity === 'error' ? 'error' : 'warning'); };
var SEVERITY_RANK = { error: 0, warning: 1, info: 2 };
var HIERARCHY_GID_FIELDS = [
    'country_gid',
    'macroregion_gid',
    'region_gid',
    'macrocounty_gid',
    'localadmin_gid',
    'locality_gid',
    'borough_gid',
    'neighbourhood_gid'
];
var LEARN_MORE_URL_KEY = 'messaging:geo_restriction.warn_on_search.learn_more_url';
// The DS toast lays out text and link in a shrinkable flex row: keep the link whole.
var LEARN_MORE_LINK_STYLE = { whiteSpace: 'nowrap', flexShrink: 0 };
// i18n returns the key itself when a translation is missing, so a truthy check is not enough.
var resolveLearnMoreUrl = function () {
    if (!i18n.exists(LEARN_MORE_URL_KEY))
        return null;
    var url = i18n.t(LEARN_MORE_URL_KEY);
    return /^https?:\/\//.test(url) ? url : null;
};
var pickMostSevereRestriction = function (restrictions) {
    return restrictions.reduce(function (mostSevere, restriction) {
        return SEVERITY_RANK[restriction.severity] < SEVERITY_RANK[mostSevere.severity] ? restriction : mostSevere;
    }, restrictions[0]);
};
var useTravelSafetyAdvisory = function (locationIds, context) {
    var showToast = useToast().showToast;
    var showToastRef = useRef(showToast);
    useEffect(function () {
        showToastRef.current = showToast;
    }, [showToast]);
    useEffect(function () {
        if (!locationIds.length)
            return undefined;
        var cancelled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var hierarchy, hierarchyIds, allIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AutocompleteService.getPlaceHierarchy(locationIds[0])];
                    case 1:
                        hierarchy = _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        hierarchyIds = (hierarchy ? HIERARCHY_GID_FIELDS.map(function (field) { return hierarchy[field]; }) : []).filter(function (id) { return Boolean(id); });
                        allIds = Array.from(new Set(__spreadArray(__spreadArray([], locationIds, true), hierarchyIds, true)));
                        GeoRestrictions.resolve(allIds, context, i18n.language)
                            .then(function (response) {
                            if (cancelled || !(response === null || response === void 0 ? void 0 : response.matched) || response.restrictions.length === 0)
                                return;
                            var restriction = pickMostSevereRestriction(response.restrictions);
                            var learnMoreUrl = resolveLearnMoreUrl();
                            showToastRef.current(__assign({ status: toToastStatus(restriction.severity), text: i18n.t('search:toast_search_travelSafetyDisclaimer_label') }, (learnMoreUrl
                                ? {
                                    link: {
                                        children: i18n.t('global:global.learnmore'),
                                        style: LEARN_MORE_LINK_STYLE,
                                        onClick: function () { return window.open(learnMoreUrl, '_blank', 'noopener,noreferrer'); }
                                    }
                                }
                                : {})));
                        })
                            .catch(function (error) {
                            console.error('Failed to resolve travel-safety advisories:', error);
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            cancelled = true;
        };
    }, [locationIds, context]);
};
export default useTravelSafetyAdvisory;
